import { StyledButton, StyledDirections } from '@/components/styles';
import { ActiveLink } from '@/components';
import Swiper from 'react-id-swiper';
import genLinkParams from '@/lib/generateLinkParams';

export default function Directions({ directions, active, onClick, size = 'large', center, asLinks = false }) {
  const activeI = [...directions].findIndex((dir) => dir?.slug == active?.slug);
  const params = {
    slidesPerView: 'auto',
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    initialSlide: activeI,
    updateOnWindowResize: true,
    on: {
      update: function () {
        this.slideTo([...directions].findIndex((dir) => dir?.slug == active?.slug));
      },
    },
  };

  const renderItem = (direction) => {
    const { id, title, slug, children = [] } = direction;
    const isActive = active?.slug == slug;
    const [href, as] = slug ? genLinkParams({ type: 'direction', slug }) : [];

    return (
      <StyledDirections.Item key={id}>
        {asLinks && href && as ? (
          <ActiveLink href={href} as={as} addHrefActive={true} activeAs="a">
            <StyledButton as="a" size={size} light={!isActive}>
              {title}
            </StyledButton>
          </ActiveLink>
        ) : (
          <StyledButton size={size} light={!isActive} onClick={() => onClick && onClick(slug)}>
            {title}
          </StyledButton>
        )}
      </StyledDirections.Item>
    );
  };

  return (
    <StyledDirections size={size} center={center}>
      <StyledDirections.Content>
        <Swiper {...params}>{directions.map(renderItem)}</Swiper>
      </StyledDirections.Content>
    </StyledDirections>
  );
}
